/**
 * Registers `v-can` and `<Can>` globally (main.ts: app.use(rbacPlugin)).
 */
import type { Plugin } from 'vue';
import Can from './CanGate';
import { vCan } from './vCan';

export const rbacPlugin: Plugin = {
  install(app) {
    app.directive('can', vCan);
    app.component('Can', Can);
  },
};

declare module 'vue' {
  export interface GlobalComponents {
    Can: typeof Can;
  }
  export interface GlobalDirectives {
    vCan: typeof vCan;
  }
}
